import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState } from 'react';
import { useMeasure } from 'react-use'; // import Collapse from '@mui/material/Collapse';

import { remCalc } from '@/config/design';
import globalEvents from '@/utils/globalEvents';
import { deleteNotTruthey, deleteUndefinedValues } from '@/utils/objects';
import { flatObjectHash } from '@/utils/widget/hashing';
import { getSectionHeadingId } from '../../internal/utils'; // import HeaderTooltip from '@/components/Tooltip';

import EditableText from '@/components/EditableText';
import StyleVariables, { getSectionAttrSelector } from '../../../misc/StyleVariables';
import styles from './styles.module.scss'; // import commonStyles from '../../styles/common.module.scss';
// import InfoIcon from '../../../../../../../public/icons/info.svg';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SectionHeader = _ref => {
  let {
    widgetId,
    sectionId,
    config,
    tooltip,
    className,
    editing = false
  } = _ref;
  const {
    title,
    titleAttrs = {},
    subHeading,
    subHeadingAttrs = {}
  } = config;
  const {
    1:
    /*isTitleFocused*/
    setIsTitleFocused
  } = useState(false);
  const {
    1:
    /*isSubHeadingFocused*/
    setIsSubHeadingFocused
  } = useState(false); // Measure the height of the container
  // to correctly calculate section height

  const [containerRef, {
    height
  }] = useMeasure();

  const handleChange = (data, options) => {
    const titleKey = (options === null || options === void 0 ? void 0 : options.titleKey) || 'title';
    const titleAttrsKey = (options === null || options === void 0 ? void 0 : options.titleAttrsKey) || 'titleAttrs';
    const styles = deleteNotTruthey(data.styles);
    const result = {
      [titleKey]: data.content,
      [titleAttrsKey]: deleteNotTruthey({
        styles: Object.keys(styles).length > 0 ? styles : undefined,
        tag: data.tag,
        alignment: data.alignment
      })
    };
    globalEvents.trigger('activeSectionEdit', {
      detail: syncAlignment(result, {
        titleAttrs,
        subHeadingAttrs
      })
    });
  }; // const isEmptyFieldsVisible =
  //   editing && (isTitleFocused || isSubHeadingFocused);
  // Make sure the header is rendered if title or subheading is present


  const hasHeading = (config === null || config === void 0 ? void 0 : config.hasHeading) || (title || subHeading) && (config === null || config === void 0 ? void 0 : config.hasHeading) !== false; // Remove header if there's nothing to render

  if (!title && !tooltip && !subHeading && !editing || !hasHeading) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [height ? /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: {
        sectionHeaderHeight: remCalc(height)
      }
    }) : null, /*#__PURE__*/_jsx("header", {
      ref: containerRef,
      className: clsx(styles.header, className),
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.titleContainer,
        children: [!title && !editing ? null : /*#__PURE__*/_jsx(EditableText, _objectSpread({
          id: getSectionHeadingId(widgetId, sectionId),
          editable: editing,
          placeholder: "Untitled",
          initialContent: title,
          initialTag: titleAttrs.tag,
          initialAlignment: titleAttrs.alignment,
          initialStyles: titleAttrs.styles,
          colorPallet: config === null || config === void 0 ? void 0 : config.colorPallet,
          onOpenChange: open => {
            setTimeout(() => setIsTitleFocused(open), 100);
          }
        }, editing ? {
          onChange: handleChange
        } : {
          key: getHeadingKey(title, titleAttrs)
        })), /*#__PURE__*/_jsx(EditableText, _objectSpread({
          editable: editing,
          placeholder: "Enter Subheading",
          initialContent: subHeading,
          initialTag: subHeadingAttrs.tag || 'p',
          initialAlignment: subHeadingAttrs.alignment,
          initialStyles: subHeadingAttrs.styles,
          toolbarPlacement: "bottom",
          className: styles.subHeading,
          colorPallet: config === null || config === void 0 ? void 0 : config.colorPallet,
          onOpenChange: open => {
            setTimeout(() => setIsSubHeadingFocused(open), 100);
          }
        }, editing ? {
          onChange: data => handleChange(data, {
            titleKey: 'subHeading',
            titleAttrsKey: 'subHeadingAttrs'
          })
        } : {
          key: getHeadingKey(subHeading, subHeadingAttrs)
        }))]
      })
    })]
  });
}; // Generate a unique key for the heading based on its text and attributes
// This helps ensure the component updates correctly when heading data changes


function getHeadingKey(text, attrs) {
  return `${text || ''}:${flatObjectHash(attrs)}`;
} // Synchronizes the alignment property for title and subheading attributes


function syncAlignment(data, ctx) {
  var _data$titleAttrs, _data$subHeadingAttrs;

  const titleAttrs = data.titleAttrs ?? (ctx === null || ctx === void 0 ? void 0 : ctx.titleAttrs);
  const subHeadingAttrs = data.subHeadingAttrs ?? (ctx === null || ctx === void 0 ? void 0 : ctx.subHeadingAttrs);
  const isCentered = (data === null || data === void 0 ? void 0 : (_data$titleAttrs = data.titleAttrs) === null || _data$titleAttrs === void 0 ? void 0 : _data$titleAttrs.alignment) === 'center' || (data === null || data === void 0 ? void 0 : (_data$subHeadingAttrs = data.subHeadingAttrs) === null || _data$subHeadingAttrs === void 0 ? void 0 : _data$subHeadingAttrs.alignment) === 'center';
  const newAlignment = isCentered ? 'center' : undefined;
  return _objectSpread(_objectSpread({}, data), {}, {
    titleAttrs: updateAttributes(titleAttrs, newAlignment),
    subHeadingAttrs: updateAttributes(subHeadingAttrs, newAlignment)
  });
}

function updateAttributes(originalAttrs, newAlignment) {
  const tempAttrs = _objectSpread(_objectSpread({}, originalAttrs), {}, {
    alignment: newAlignment
  });

  const cleaned = deleteUndefinedValues(tempAttrs);
  return Object.keys(cleaned).length > 0 ? cleaned : null;
}

export default SectionHeader;